import React, { useEffect, useState } from "react";
import api from "api";

export default function AdminCategoriesSelect({
  value,
  onChange,
  placeholder = "Sélectionner une catégorie…"
}) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // ----------------------------------------------------
  // Load categories
  // ----------------------------------------------------
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await api.get("/admin/formalities/categories");
        setCategories(res.data || []);
      } catch (e) {
        console.error("LOAD CATEGORIES ERROR", e);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // ----------------------------------------------------
  // Render
  // ----------------------------------------------------
  const isEmpty = !loading && categories.length === 0;

  return (
    <select
      className="form-select"
      disabled={loading || isEmpty}
      value={value || ""}
      onChange={(e) => onChange(e.target.value || null)}
    >
      {loading && <option>Chargement…</option>}

      {isEmpty && <option>Aucune catégorie</option>}

      {!loading && !isEmpty && (
        <>
          <option value="">{placeholder}</option>
          {categories.map((cat) => (
            <option key={cat.fcId} value={cat.fcId}>
              {cat.fcName}
            </option>
          ))}
        </>
      )}
    </select>
  );
}
